module.exports = __webpack_public_path__ + "images/emoji/speech_balloon.67d02d82075a5b456623.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/speech_balloon.png
// module id = d0rc
// module chunks = 14